import axios from 'axios';
import qs from 'qs';

export const httpClient = axios.create({
	timeout: 5000,
	paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
});
